export default "__VITE_ASSET__BSfpxjNE__"